import loader from "_src/loader";
import output from "_src/engine/output";
import {pixelBufferType, primitiveType, textureMagFilter, textureMinFilter} from "_src/engine/constants";
import bufferFactory from "_src/engine/factories/pixel_buffer";
import DefaultShader from "_src/shaders/default/default_shader";
import objFactory from "_src/engine/factories/object";
import primitiveFactory from "_src/engine/factories/primitive";
import {screenUtils} from "_src/client/utils";
import rotationIndicator from "_assets/textures/rotation_indicator.png";
import {colorType} from "_src/constants";

const SCREEN_SIZE = 8;
let texturePromise = null;

async function loadTexture() {
  try {
    const image = await loader.load(rotationIndicator, loader.IMAGE);

    if (!image) {
      output.error(output.DEVELOPERS_ERROR, "Couldn't load rotation indicator texture.");
      return null;
    }

    const minFilter = textureMinFilter.LINEAR;
    const magFilter = textureMagFilter.LINEAR;

    const texture = bufferFactory.create(pixelBufferType.T_RGBA, {
      width: image.width, height: image.height,
      minFilter, magFilter, immutable: true, flipY: true
    });
    texture.initMipMapLevelImage(0, image);

    return texture;
  } catch (error) {
    
    if (!loader.isLegalError(error)) {
      output.error(output.DEVELOPERS_ERROR, "Couldn't load rotation indicator texture. " + error.message);
    }
    return null;
  }
}

async function getTexture() {
  if (!texturePromise) {
    texturePromise = loadTexture();
  }

  const texture = await texturePromise;
  return texture;
}

export class RotationIndicator {
  constructor(camera) {
    const shader = new DefaultShader({
      transparent: true,
      lighting: false,
      depthTest: false,
      colorMode: colorType.TEXTURE_UV,
    });

    this.rotationIndicatorObject = objFactory.createDrawable(shader);
    this.rotationIndicatorObject.addGeometryChunk(primitiveFactory.create(primitiveType.PLANE, {width : 1, height : 1}));
    this.rotationIndicatorObject.setVisibility(false);
    this.camera = camera;
  }

  async register(scene) {
    const texture = await getTexture();
    if (texture) {
      this.rotationIndicatorObject.setTexture(texture, 0);
      scene.add(this.rotationIndicatorObject);
    }
  }

  unregister(scene) {
    scene.remove(this.rotationIndicatorObject);
  }

  update() {
    this.rotationIndicatorObject.copyRotation(this.camera.quat);
    const scale = screenUtils.calculateObjectScale(SCREEN_SIZE, 1, this.rotationIndicatorObject.getTranslation(), this.camera);
    this.rotationIndicatorObject.setScale(scale, scale, scale);
  }

  setVisibility(visibility) {
    this.rotationIndicatorObject.setVisibility(visibility);
  }

  move(point) {
    this.rotationIndicatorObject.setTranslation(...point);
    this.update();
  }

}

export function cleanupRotationIndicator() {
  texturePromise = null;
}
